













































































































import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";
import OrderSummary from "@/components/OrderSummary.vue";
import StoreLayout from "@/components/StoreLayout.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import CCreditCard from "@/components/CCreditCard.vue";
import { IEcertBalanceInfo, StorePriceDisplayType, Utils } from "chipply-common";
import { loadStripe, Stripe, StripeElements, StripePaymentElement } from "@stripe/stripe-js";
import OrderTotalSummary from "../price/OrderTotalSummary.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: {
        OrderTotalSummary,
        OrderSummary,
        StoreLayout,
        CCreditCard,
    },
})
export default class CheckoutReviewRevised extends Vue {
    public Utils = Utils;
    public StorePriceDisplayType = StorePriceDisplayType;

    public $refs!: {
        creditCardContainer: HTMLDivElement;
    };

    public get mobile() {
        return !this.$vuetify.breakpoint.smAndUp;
    }

    public name = "CheckoutReview";
    @Prop({ default: {} })
    public vm!: CheckoutReviewViewModel;
    protected readonly eventIdParamName = "eventid";
    public loading = false;
    public paymentElement: StripePaymentElement | null | undefined = null;
    public previouslyMounted = false;

    public get priceDisplay(): IPriceDisplay {
        return {
            displayType: this.vm.branding.storePriceDisplayType,
            dollarValuePerPoint: this.vm.branding.storeDollarValuePerPoint ?? 0,
        };
    }

    public async mounted() {
        if (this.previouslyMounted) {
            return;
        }

        this.$nextTick(() => {
            if (!this.$refs.creditCardContainer) {
                return;
            }

            this.paymentElement = this.vm.stripeElementsInstance!.create("payment");
            this.paymentElement!.mount(this.$refs.creditCardContainer);
        });
        this.previouslyMounted = true;
    }

    //write code to load stripe

    public async emitRequest() {
        var results = await this.vm.placeOrder();
        this.$emit("orderPlaced", results);
    }

    private get itemTotal() {
        let itemTotal = 0;
        this.vm.items.forEach((item) => {
            itemTotal += item.qty;
        });
        return itemTotal;
    }
}
